import { DescriptionList, DescriptionTerm } from "@/components";
import { formatDateTimeString } from "@/utils";

export const BekreftelseTidspunkt = ({
  opprettet,
  endret,
  avbestilt,
}: {
  opprettet?: string;
  endret?: string | null | undefined;
  avbestilt?: string | null | undefined;
}) => {
  return (
    <DescriptionList>
      {opprettet && (
        <DescriptionTerm
          tranlsationFeltKey="pages.bekreftelse.tidspunkt.opprettet"
          value={formatDateTimeString(opprettet, "long")}
        />
      )}
      {endret && (
        <DescriptionTerm
          tranlsationFeltKey="pages.bekreftelse.tidspunkt.endret"
          value={formatDateTimeString(endret, "long")}
        />
      )}
      {avbestilt && (
        <DescriptionTerm
          tranlsationFeltKey="pages.bekreftelse.tidspunkt.avbestilt"
          value={formatDateTimeString(avbestilt, "long")}
        />
      )}
    </DescriptionList>
  );
};
